import { executeRequest, Request } from '@jfs/network'
import { actionMenuStrings } from '../data/static/strings'
import { RootStore } from '../data/store'
import { updateEndDateTimeInRequest } from '../util/util'
import { APIEndPoints } from './APIEndpoints'
import { summaryConfig } from './config'
import { formatSegmetedData, getChartData, getLegendData, getTypesArray } from './parsers/getInsightRecordParser'

const responseParser = (data: any, segmentedBy: any, transactionsBy: any, segmentedVs: any) => {
  let formattedSegmentedData
  let formatedDataForGraph
  let formatedPercentDataForGraph
  let xAxis
  let maxVal
  let typeKeysArray = getTypesArray(RootStore.insights.segmentByData.slice())
  if (data.insightDetails) {
    //const segmentedDataStringArray = Object.keys(data?.graphDetails?.graphData)
    formattedSegmentedData = formatSegmetedData(data.insightDetails[segmentedBy])
    typeKeysArray = getTypesArray(data.insightDetails[segmentedBy])
  } else {
    if (segmentedVs?.length > 0) {
      formattedSegmentedData = getLegendData(data?.vsGraphDetails?.graphData)
      typeKeysArray = getTypesArray(formattedSegmentedData)
    }
  }
  if (data.graphDetails) {
    const dataForGraph = getChartData(data.graphDetails, typeKeysArray, transactionsBy, false, false)
    formatedDataForGraph = dataForGraph.data
    const percentData = getChartData(data.graphDetails, typeKeysArray, transactionsBy, true, false)
    formatedPercentDataForGraph = percentData.data
    xAxis =
      percentData.xAxis.length > 0
        ? getxAxisData(percentData.xAxis)
        : dataForGraph.xAxis.length > 0
        ? getxAxisData(dataForGraph.xAxis)
        : []
    maxVal = Number(data?.graphDetails?.maxValue ?? 0)
  } else if (data.vsGraphDetails) {
    const dataForGraph = getChartData(data.vsGraphDetails, typeKeysArray, transactionsBy, false, true)
    formatedDataForGraph = dataForGraph.data
    const percentData = getChartData(data.vsGraphDetails, typeKeysArray, transactionsBy, true, true)
    formatedPercentDataForGraph = percentData.data
    xAxis =
      percentData.xAxis.length > 0
        ? getxAxisData(percentData.xAxis)
        : dataForGraph.xAxis.length > 0
        ? getxAxisData(dataForGraph.xAxis)
        : []
    maxVal = Number(data?.vsGraphDetails?.maxValue ?? 0)
  }
  return {
    segmentByData: formattedSegmentedData,
    data: formatedDataForGraph,
    maxVal: maxVal,
    percentData: formatedPercentDataForGraph,
    xAxis: xAxis,
  }
}

const getxAxisData = (data: any) => {
  return data.map((text: string) => {
    return {
      text: text,
      isChecked: true,
    }
  })
}

const getTempIdentifier = (reqBody: any) => {
  if (reqBody.dateValue === 'Today') {
    //Fix for bar_data usecase of dateValue is Today and segmentedVs is changed
    if (reqBody?.segmentedVs?.length > 0) {
      return 'bar_data'
    } else if (reqBody?.segmentedVs?.length !== 0) {
      return reqBody.durationType
    }
    return 'Today'
  }
  if (reqBody.showByPercentage) {
    return 'percentage'
  }
  return reqBody?.segmentedVs?.length > 0 ? 'bar_data' : reqBody.durationType
}

const segmentedByWrapper: any = {
  'Payment Method': 'Payment_Method',
  'Card Networks': 'Processor',
  Bank: 'Bank',
  Status: 'Status',
  Platform: 'Platform',
  Wallet: 'Wallet',
}

const getReqObject = (reqBody: any) => {
  const transactionType: any = {
    Count: 'by_Count',
    Value: 'by_Value',
  }

  const toDate = reqBody.toDate

  return {
    inputFilter: {
      merchantId: reqBody.mid,
      responseType: 'DEFAULT',
      startDateTime: reqBody.fromDate,
      endDateTime: toDate,
      transactionType: reqBody.type,
      view_Transaction: transactionType[reqBody.transactions],
      segmentedBy: segmentedByWrapper[reqBody.segmentedBy],
      time: reqBody.durationType,
      showPercent: reqBody.showPercent,
      segmentedVs: segmentedByWrapper[reqBody.segmentedVs],
    },
    configParams: {
      mediaType: 'JSON',
    },
    // TODO: added to send diff response
    tempData: getTempIdentifier(reqBody),
    outputDomain: [],
  }
}

const getInsightsRecord = (tokens: any, reqBody: any) => {
  const isCustomRange = RootStore.insights.graphPrefrences.dateValue === actionMenuStrings.customDate
  //|| RootStore.insights.graphPrefrences.dateValue === actionMenuStrings.yesterday
  //console.log('isCustomRange', RootStore.insights.graphPrefrences.selectedDate)
  const reqObject = getReqObject(reqBody)
  const request: Request<{}> = {
    config: summaryConfig(tokens, ''),
    apiPath: APIEndPoints.getInsightsRecord,
    method: 'POST',
    cache: false,
    body: isCustomRange
      ? reqObject
      : updateEndDateTimeInRequest(reqObject, RootStore.insights.graphPrefrences.selectedDate),
  }
  return executeRequest(request).then((data) => {
    return responseParser(
      data?.data?.data,
      segmentedByWrapper[reqBody.segmentedBy],
      reqObject?.inputFilter?.view_Transaction ?? '',
      reqBody?.segmentedVs,
    )
  })
}

export { getInsightsRecord }
